import React, {Component} from 'react';
import MarkupToolButton from './MarkupToolButton';
import classNames from 'classnames';
import {ReactComponent as IconUndo} from '../../../assets/images/studio/markup/icon-undo.svg';
import {ReactComponent as IconRedo} from '../../../assets/images/studio/markup/icon-redo.svg';
import {ReactComponent as Xicon} from "../../../assets/images/x-icon.svg";

class MarkupRightActions extends Component {

    undoHandle = (e) => {
        e.preventDefault();
        if (this.props.undo) {
            this.props.undo();
        }
    };

    redoHandle = (e) => {
        e.preventDefault();
        if (this.props.redo) {
            this.props.redo();
        }
    };

    render() {
        const {canUndo, canRedo, toggleColorPicker, activeColor, showActions, closeHandle, disableColor} = this.props

        const rightActionsClasses = classNames({
            'markup-right-actions': true,
            'with-actions': showActions
        })


        return (
            <div className={rightActionsClasses}>
                {showActions &&
                <>
                    <MarkupToolButton icon={<IconUndo/>} onClick={this.undoHandle} toolTipText="markup.tooltip.undo" iconViewBox={'0 0 16 16'} buttonClass='undo'
                                      disabled={!canUndo}/>
                    <MarkupToolButton icon={<IconRedo/>} onClick={this.redoHandle} toolTipText="markup.tooltip.redo" iconViewBox={'0 0 16 16'} buttonClass='redo'
                                      disabled={!canRedo}/>
                    <button className='color' onClick={toggleColorPicker} disabled={disableColor}>
                        <span style={{backgroundColor: activeColor}}/>
                    </button>
                </>
                }
                {!showActions &&
                    <MarkupToolButton icon={<Xicon/>} onClick={closeHandle} toolTipText="markup.tooltip.close" buttonClass='markup-done'/>
                }
            </div>
        );
    }
}

export default MarkupRightActions;
